import React, { useState } from 'react';
import { 
  MessageSquare, 
  FileSearch, 
  PenTool, 
  Code2, 
  Rocket,
  CheckCircle,
  ArrowRight
} from 'lucide-react';
import SolutionsDialog from '../solutions/SolutionsDialog';

const workflowSteps = [
  // ... keep existing workflowSteps array ...
];

export default function HowWeWork() {
  const [showConsultation, setShowConsultation] = useState(false);

  return (
    <section className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl">
            How We Work
          </h2>
          <p className="mt-4 text-xl text-gray-600 dark:text-gray-300">
            A transparent, efficient process focused on your success
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {workflowSteps.map((step) => {
            const Icon = step.icon;
            return (
              <div
                key={step.id}
                className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                <div className={`p-6 bg-gradient-to-r ${step.gradient}`}>
                  <div className="flex items-center mb-4">
                    <Icon className="w-8 h-8 text-white" />
                    <span className="ml-4 text-2xl font-bold text-white">
                      {step.id}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">
                    {step.title}
                  </h3>
                  <p className="text-white text-opacity-90">
                    {step.description}
                  </p>
                </div>
                
                <div className="p-6">
                  <ul className="space-y-3">
                    {step.details.map((detail, index) => (
                      <li 
                        key={index}
                        className="flex items-center text-gray-700 dark:text-gray-300"
                      >
                        <div className="w-1.5 h-1.5 rounded-full bg-purple-500 mr-2" />
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="max-w-3xl mx-auto mb-8">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Ready to Get Started?
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              Schedule your free consultation today and let's discuss how we can help transform your business with AI.
            </p>
          </div>
          <button
            onClick={() => setShowConsultation(true)}
            className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-colors duration-300"
          >
            Schedule Consultation
            <ArrowRight className="ml-2 -mr-1 h-5 w-5" />
          </button>
        </div>

        <SolutionsDialog 
          isOpen={showConsultation}
          onClose={() => setShowConsultation(false)}
        />
      </div>
    </section>
  );
}